import { ImportFileParams } from "src/core/process-job/api/processJobs.api";
import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";

export interface TerminologyItem {
  plural: {
    text: string;
  },
  singular: {
    text: string;
  },
}

// creates terminology item
export const transformTerminologyItem = (plural: string, singular: string): TerminologyItem => {
  return {
    plural: { text: plural },
    singular: { text: singular }
  };
};

// creates terminology item based on type
export const setLocalTerminology = (type: ImportFileParams["type"], terminology: ITerminology): TerminologyItem => {
  switch (type) {
    case "price": {
      return transformTerminologyItem("prices", "price");
    }
    case "nutrition": {
      return transformTerminologyItem("nutritional data", "nutrition");
    }
    case "product-approval": {
      return transformTerminologyItem("product approval lists", "product approval list");
    }
    default: {
      return terminology[ type as keyof ITerminology ];
    }
  }
};
